export default __webpack_public_path__ + "static/media/hospital.f9c91983.png";